import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../services/account/account.service';
import { StaffNoteService } from '../../../../../../services/staff-note/staff-note.service';
import { StaffNote } from '../../../../../../models/staff-note';

@Component({
  selector: 'app-add-staff-note',
  templateUrl: './add-staff-note-modal.component.html',
  styleUrls: ['./add-staff-note-modal.component.css']
})
export class AddStaffNoteModalComponent implements OnInit {

  @Input() savedCallback: () => undefined;

  public staffNote: StaffNote = {
    id: null,
    url: null,
    text: '',
    is_dismissed: false,
    created_by_id: null,
    created_by_first_name: null,
    created_by_last_name: null,
    created_by_email: null,
    last_updated_by_id: null,
    last_updated_by_first_name: null,
    last_updated_by_last_name: null,
    last_updated_by_email: null,
    created_at: null,
    updated_at: null
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public staffNoteService: StaffNoteService
  ) {}

  ngOnInit() {
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.staffNoteService
      .addStaffNote(this.staffNote)
      .then(createdStaffNote => {
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
